<template>
  <div class="landing">
    <div class="intro">

      <h1><img src="../assets/images/sift-logo.png" alt="Sift"  class="sift-logo"/> <span>| /sɪft/ | verb</span></h1>
      <ol>
        <li>To take a relaxed approach to life.</li>
        <li>To do nothing with a purpose</li>
        <li>{{ quip }}</li>
      </ol>
      <div class="signup"><router-link to="/join" class="button">Join</router-link> or <a href="https://sift.life/login" class="button">Login</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiftLanding',
  data () {
    return {
      quip: 'An online community for people who love mountain biking, the outdoors or just talking crap on the internet.'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SiftLanding.vue